import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Swiper from 'react-id-swiper';
import { connect } from 'react-redux';
import { Modal } from '../index';
import { UpgradeCard } from '../../components/index';
import { onFreePassClick, closeModal } from '../../redux/actions';

import {
  TimeOffer,
  Header,
  SubHeading,
  CloseBtn,
  UpgradeContainer,
  UpgradeCardWrapper,
  UpgradeCardSingle,
} from './styles';

const params = {
  slidesPerView: 'auto',
  spaceBetween: 15,
  freeMode: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
};

const mapStateToProps = state => ({
  userProducts: state.userProduct.hotel.products,
  guests: state.userPreferences.guests,
  userProduct: state.userProduct,
  userPreferences: state.userPreferences,
  userData: state.user.userData,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleFreePass: onFreePassClick,
  closeUpgradeModal: closeModal,

}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class UpgradeToCabanaModal extends Component {

  static propTypes = {
    userProducts: PropTypes.instanceOf(Array),
    userPreferences: PropTypes.instanceOf(Object),
    userProduct: PropTypes.instanceOf(Object),
    userData: PropTypes.instanceOf(Object),
    handleFreePass: PropTypes.func,
    closeUpgradeModal: PropTypes.func,
  };

  swiper = null;

  timeout = null;

  async componentDidMount() {
    this.timeout = setTimeout(() => {
      this.timeout = null;
      this.upgradeFailRouteChange();
    }, 180000)
  };

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  };

  upgradeFailRouteChange = () => {
    const { closeUpgradeModal, formFunc, formData } = this.props;

    formFunc(formData, 'checkout');

    closeUpgradeModal();
  };

  render() {
    const { upgradeFailRouteChange } = this;

    const { formFunc, formData, filteredUpgradeVariants, multi } = this.props;

    return (
      <Modal empty customCloseFunc={upgradeFailRouteChange} maxWidth='690px' mobileMaxWidth='300px'>
        <UpgradeContainer multi={multi}>
          <TimeOffer>LIMITED TIME OFFER</TimeOffer>
          <Header>Upgrade Your Experience</Header>
          <SubHeading>Upgrade to a VIP private space and relax in style!</SubHeading>
          { filteredUpgradeVariants && filteredUpgradeVariants.length > 1 ?
              (
                <Swiper
                  {...params}
                  ref={node => {
                      if (node) this.swiper = node.swiper;
                  }}
                >
                  { filteredUpgradeVariants.map((e) => (
                    <UpgradeCardWrapper>
                      <UpgradeCard multi formFunc={formFunc} formData={formData} product={e} {...e} key={e.id} />
                    </UpgradeCardWrapper>
                    ))}
                </Swiper>
              )
            :
              (
                <UpgradeCardSingle>
                  <UpgradeCard 
                    formFunc={formFunc} 
                    formData={formData} 
                    product={filteredUpgradeVariants[0]} 
                    {...filteredUpgradeVariants[0]}
                  />
                </UpgradeCardSingle>
              )

          }

          {/* <CloseBtn type='button' onClick={upgradeFailRouteChange} multi={multi}>No, Thanks, I like GA</CloseBtn> */}
          
          <div className="noThanks">
            <span onClick={this.upgradeFailRouteChange}>No, Thanks, I like GA</span>
          </div>
        </UpgradeContainer>
        
      </Modal>

    );
  }
}

export default UpgradeToCabanaModal;
